import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_4fzjm5r3cv: FaireCollectionEntity = {
  token: "pbc_4fzjm5r3cv",
  type: "collection",
  name: "Pre-Order FW26 Joyful Days - Ski Collection",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e2d33d9d39bf749ebf9bbf62b19fc61a8123ede5d23b4cbfb52e2f398692826f.jpeg",
  itemCount: 1,
  description:
    "The Viverano Organics Ski Baby Collection is thoughtfully designed for little ones during the winter season, combining cozy comfort with premium craftsmanship. Made from soft organic fabrics that are gentle on delicate skin, each piece is designed to keep babies warm and cozy.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:15.996Z",
    importedBy: "entity-db-import-collections",
  },
};
